<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div v-if="!isLoading" class="cart">
      <div class="container">
        <div class="row">
          <div class="col-4">
            <button
              class="cart-buttons"
              style="  background: linear-gradient(to left, #05cefc, #5659ce); color: #fff"
            >
              Cart
            </button>
          </div>
          <div class="col-4"><button class="cart-buttons">Billing</button></div>
          <div class="col-4"><button class="cart-buttons">Review</button></div>
        </div>
        <div class="row">
          <div v-if="cart.length > 0" class="title mt-5">
            <h4>Shopping Cart</h4>
          </div>
          <div v-if="cart.length > 0" class="items-card">
            <div v-for="item in cart" v-bind:key="item._id" class="cart-item">
              <div class="left-wing">
                <div class="img-container">
                  <img
                    width="100%"
                    height="100%"
                    v-bind:src="
                      'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                        item.product.images[0]
                    "
                    alt=""
                  />
                </div>
                <div class="info">
                  <div class="item-title">
                    <h5>{{ item.product.title }}</h5>
                  </div>
                  <div
                    v-if="(item.product.types || []).length == 0"
                    class="item-stock"
                  >
                    {{ item.product.stock > 0 ? "In Stock" : "Not Available" }}
                  </div>
                  <div
                    v-if="(item.product.types || []).length != 0"
                    class="item-stock"
                  >
                    {{ item.product.types[0].groupName }} :
                    {{ item.product.types[0].value }}
                  </div>
                </div>
              </div>
              <div class="right-wing">
                <div class="price">
                  <h5>
                    {{
                      (item.totalPrice / item.totalQuantities -
                        (item.totalPrice / item.totalQuantities) *
                          (item.product.discountPercentage / 100) *
                          1)
                        | toCurrency
                    }}
                    IQD
                  </h5>
                </div>
                <div class="options mt-4">
                  <button @click="deleteFromCart(item._id)" class="options-btn">
                    Delete
                  </button>
                  <button
                    class="options-btn"
                    style="display: flex;justify-content: space-between; padding: 4px; width: 130px"
                  >
                    <span
                      id="chipss2"
                      style="font-size: 18px; color: white;"
                      @click="updateQuantities(item._id, '--')"
                      >-</span
                    >
                    <span style="font-size: 18px; color: black">{{
                      item.totalQuantities
                    }}</span>
                    <span
                      id="chipss"
                      style="font-size: 18px; color: white"
                      @click="updateQuantities(item._id, '++')"
                      >+</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- <h2 v-if="cart.length == 0" style="text-align: center; width: 100%; margin-top: 50px">Your cart is empty <a href="/categories">shop now</a></h2> -->
        </div>
        <!-- <div v-if="cart.length == 0" class="row centred">
              <lottie-player
                     src="https://assets5.lottiefiles.com/datafiles/cS1fvpgbDlcx9hc/data.json"  background="transparent"  speed="1"  style="width: 250px; height: 250px"  autoplay >
              </lottie-player>
          </div> -->
        <div v-if="cart.length == 0">
          <div class="row centred">
            <lottie-player
              src="https://assets10.lottiefiles.com/temp/lf20_jzqS18.json"
              background="transparent"
              speed="1"
              style="width: 300px; height: 300px"
              loop
              autoplay
            >
            </lottie-player>
          </div>
          <div class="row centred message">
            Your cart is empty
            <img
              src="https://img.icons8.com/color/22/000000/question--v1.png"
            />
          </div>
          <div class="row centred link pb-3">
            <a href="/">
              contnue shopping
              <img
                src="https://img.icons8.com/color/25/000000/shopping-cart.png"
              />
            </a>
          </div>
        </div>
        <div
          v-if="cart.length > 0"
          class="row mt-4"
          style="display: felx; justify-content: center;"
        >
          <div class="total-card">
            Total: {{ total_price | toCurrency }} IQD
          </div>
        </div>
        <div v-if="cart.length > 0" class="row mt-3">
          <a href="/billing" class="contnue-button"
            >Contnue to billing information</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/views/Loading";

// import router from "../router";
import axios from "axios";
export default {
  components: {
    Loading,
  },
  data: () => {
    return {
      cart: [],
      total_price: 0,
      isLoading: true,
    };
  },
  created() {
    this.getCart();
  },
  methods: {
    getCart() {
      axios
        .get("https://api.ardunic.com/v1/cart", {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.cart = res.data.data.filter(({ product }) =>
            (product.types || []).length
              ? product.types[0].stock
              : product.stock
          );

          this.isLoading = false;

          this.cart.forEach((item) => {
            this.total_price += item.totalPriceAfterDiscounted;
          });

          if (this.cart.length === 0)
            this.$store.dispatch("addToCardIncrease", {
              qty: 0,
              price: 0,
            });
          else
            this.$store.dispatch("addToCardIncrease", {
              qty: this.cart.length,
              price:
                this.cart.reduce(
                  (all, item) => (all += item.totalPriceAfterDiscounted),
                  0
                ) || 0,
            });
        });
    },
    async updateQuantities(id_product, type) {
      let data = { productId: 0, totalQuantities: 0, priceIds: [] };
      await this.cart.filter((item) => {
        if (item._id === id_product) {
          data.productId = item.product._id;
          type == "++"
            ? (data.totalQuantities = item.totalQuantities + 1)
            : (data.totalQuantities = item.totalQuantities - 1);
          (item.product.types || []).length > 0
            ? item.product.types.forEach((t) => {
                data.priceIds.push(t._id);
              })
            : (data.priceIds = []);
        }
      });
      await axios
        .post("https://api.ardunic.com/v1/cart", data, {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.getCart();
          // this.cart = res.data.data;
          this.total_price = 0;
          res.data.data.forEach((item) => {
            this.total_price += item.totalPriceAfterDiscounted;
          });
        });
    },
    deleteFromCart(id) {
      axios
        .post(
          `https://api.ardunic.com/v1/cart/${id}`,
          {},
          {
            headers: {
              access_token: localStorage.getItem("token"),
            },
          }
        )
        .then(async (res) => {
          await this.getCart();
          // this.cart = res.data.data;
          // res.data.data.forEach(item => {
          //   this.total_price +=item.totalPriceAfterDiscounted
          // });
        });
    },
  },
  computed: {
    filterdCart() {
      return this.cart.filter(({ product }) =>
        product.priceIds.length ? product.priceIds[0].stock : product.stock
      );
    },
  },
};
</script>

<style scoped>
.cart {
  margin-top: 120px;
}

.title h4 {
  font-weight: bolder;
}

.centred {
  display: flex;
  justify-content: center;
  align-items: center;
}

.message {
  font-size: 20px;
  font-weight: bold;
  color: #4a5568;
  padding-bottom: 30px;
}

.link a {
  color: #4a5568;
}

#chipss {
  background: linear-gradient(right, #ff3fbb, #ff8891);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

#chipss2 {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

.items-card {
  width: 100%;
  border-radius: 20px;
  border: 1px solid #c1c2c5;
}

.left-wing {
  display: flex;
  align-items: center;
}

.right-wing {
  margin-right: 15px;
}

.price h5 {
  color: rgb(26, 91, 211);
  text-align: right;
  font-size: 20px;
  font-weight: bolder;
}

.item-title h5 {
  font-weight: bold;
  margin-bottom: 15px;
}

.item-stock {
  font-size: 18px;
  letter-spacing: 1.6;
}
.info {
  margin-left: 10px;
}

.cart-buttons {
  width: 100%;
  padding: 20px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  color: #fff;
}

.contnue-button {
  width: 100%;
  text-align: center;
  padding: 20px 50px;
  border-radius: 10px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to right, #09f7ff, #05f040);
  color: #fff;
}

.total-card {
  width: 50%;
  text-align: center;
  padding: 10px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to left, #05cefc, #5659ce);
  color: #fff;
}

.options-btn {
  width: 100px;
  border-radius: 30px;
  border: none;
  margin-left: 5px;
  background: #fff;
  border: 1px solid #c1c2c5;
}

.options {
  display: flex;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 10px 20px 10px;
}

.cart-item:not(:last-child) {
  border-bottom: 1px solid #c1c2c5;
}

.img-container {
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-container img {
  padding: 15px;
}
</style>
